<template>
  <v-layout column class="elevation-2 white pa-3 ma-1">
    <v-layout row class="pa-3 align-center">
      <v-label v-if="signMode"
        >SIGN IN - {{ attendance.holder_type.toUpperCase() }}</v-label
      >
      <v-label v-else
        >SIGN OUT - {{ attendance.holder_type.toUpperCase() }}</v-label
      >
      <v-spacer></v-spacer>
      <v-btn
        v-if="!attendance.complete"
        color="primary"
        small
        type="submit"
        class="elevation-0"
        @click="signMode = !signMode"
        >{{ signMode ? "Sign Out" : "Sign In" }}</v-btn
      >
      <v-label v-if="attendance.complete">Sign Out Recorded</v-label>
    </v-layout>
    <v-divider class="pb-3"></v-divider>
    <v-text-field
      label="Station"
      disabled
      v-model="attendance.station"
    ></v-text-field>

    <v-layout row fluid class="pl-3 pr-3">
      <v-text-field
        label="First Name"
        :disabled="!signMode"
        v-model="attendance.first_name"
      ></v-text-field>
      <v-text-field
        class="ml-2"
        :disabled="!signMode"
        label="Last Name"
        v-model="attendance.last_name"
      ></v-text-field>
    </v-layout>

    <v-text-field
      v-if="attendance.mobile"
      label="Mobile"
      :disabled="!signMode"
      v-model="attendance.mobile"
      mask="phone"
    ></v-text-field>

    <v-flex
      xs12
      sm6
      d-flex
      class="pa-0 align-center"
      v-if="signMode && !['student', 'staff'].includes(attendance.holder_type)"
    >
      <v-label>WWCC Status</v-label>
      <v-select
        :items="wwcc_status"
        label="WWCC Card"
        solo
        v-model="attendance.wwcc_card"
      ></v-select>
    </v-flex>

    <v-layout column fluid class="pl-3 pr-3 pb-3">
      <v-label class="mb-1"
        >{{ signMode ? "Sign In" : "Sign Out" }} Date/Time
      </v-label>
      <v-layout row fluid class="pl-2 pr-3 pt-3">
        <v-menu
          class="pr-2"
          ref="statDate"
          lazy
          :close-on-content-click="false"
          v-model="datePicker"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-bottom="-22"
          max-width="290px"
          :return-value.sync="tracking_date"
        >
          <v-text-field
            slot="activator"
            v-model="tracking_date"
            label="Date (YYYY-MM-YY)"
            append-icon="event"
            readonly
          ></v-text-field>
          <v-date-picker
            v-model="tracking_date"
            no-title
            scrollable
            @change="changeFromDate(tracking_date)"
          >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="datePicker = false"
              >Cancel</v-btn
            >
            <v-btn
              flat
              color="primary"
              @click="$refs.statDate.save(tracking_date)"
              >OK</v-btn
            >
          </v-date-picker>
        </v-menu>

        <v-menu
          ref="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="timePicker"
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
          width="100px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="tracking_time"
              label="Time"
              prepend-icon="access_time"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-time-picker
            v-model="tracking_time"
            full-width
            @click:minute="$refs.menu.save(tracking_time)"
            @change="changeFromTime(tracking_time)"
          ></v-time-picker>
        </v-menu>
      </v-layout>
    </v-layout>

    <!-- reason for the tracking in/out -->
    <v-text-field
      :label="signMode ? 'Sign In Reason' : 'Sign Out Reason'"
      v-model="tracking_reason"
    ></v-text-field>

    <!-- signature image preview -->
    <v-layout v-if="attendance.image" column class="pa-3">
      <v-label style="font-size: 12px">Signature</v-label><br />
      <img :src="this.attendance.image" />
    </v-layout>

    <v-layout wrap justify-end>
      <v-spacer></v-spacer>
      <v-btn color="info" small type="submit" @click="submitSignIn"
        >Update</v-btn
      >
    </v-layout>
  </v-layout>
</template>

<script>
import APIAttendance from "@/mixins/APIAttendance";
import APIHelpers from "@/mixins/helpers";
export default {
  components: {},
  mixins: [APIAttendance, APIHelpers],
  data() {
    return {
      mobileLength: 10,
      attendance: {},

      tracking_reason: "",

      tracking_date: "",
      tracking_time: "",

      datePicker: false,
      timePicker: false,

      signMode: true
    };
  },
  watch: {
    attendance: {
      handler: function() {
        this.tracking_reason = this.attendanceIn
          ? this.attendance.sign_in_reason
          : this.attendance.sign_out_reason;

        this.tracking_time = this.attendanceIn
          ? this.attendance.sign_in_time
          : this.attendance.sign_out_time;

        this.tracking_date = this.attendanceIn
          ? this.attendance.sign_in_date
          : this.attendance.sign_out_date;

        this.signMode == this.attendanceIn;

        if (this.attendance.wwcc_card) {
          if (this.attendance.wwcc_card === 3) {
            this.attendance.wwcc_card = 2;
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    attendanceIn: function() {
      return this.attendance.sign_in_date;
    }
  },
  created() {
    this.restoreFrom();
  },
  methods: {
    restoreFrom: async function() {
      if (this.$route.params.object) {
        this.attendance = this.$route.params.object;
        if (this.attendance.image) {
          this.attendance.image =
            "data:image/jpeg;base64," + this.attendance.signature;
        }
      } else if (this.$route.params.id) {
        try {
          let res = await this.getSignedInById(this.$route.params.id);
          this.attendance = res[0];

          if (this.attendance.image) {
            this.attendance.image =
              "data:image/jpeg;base64," + this.attendance.signature;
          }
        } catch (error) {
          this.$toast.error("Failed to fetch details", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    changeFromDate: function(date) {
      this.tracking_date = date;
    },
    changeFromTime: function(time) {
      if (time === 5) {
        this.tracking_time = time + ":00";
      } else {
        this.tracking_time = time;
      }
    },
    submitSignIn: async function() {
      try {
        if (this.signMode) {
          this.attendance.sign_in_time = this.tracking_time;
          if (this.attendance.sign_in_time.length === 5) {
            this.attendance.sign_in_time = this.tracking_time + ":00";
          }
          this.attendance.sign_in_date = this.tracking_date;
          this.attendance.sign_in_reason = this.tracking_reason;
        } else {
          this.attendance.sign_out_time = this.tracking_time;
          if (this.attendance.sign_out_time.length === 5) {
            this.attendance.sign_out_time = this.tracking_time + ":00";
          }
          this.attendance.sign_out_date = this.tracking_date;
          this.attendance.sign_out_reason = this.tracking_reason;
        }

        if (this.signMode) {
          await this.putSignIn(this.attendance);
        } else {
          await this.putInToSignout(this.attendance);
        }

        this.$router.push({
          name: "Signed in"
        });
        this.$toast.success("Record successfully updated.", "Success", {
          position: "topCenter"
        });
      } catch (error) {
        this.$toast.error("Failed to update record details.", "Error", {
          position: "topCenter"
        });
      }
    }
    //   submitSignout: async function() {
    //     try {
    //       if (this.attendanceIn) {
    //         this.attendance.sign_in_time = this.tracking_time;
    //       } else {
    //         this.attendance.sign_out_time = this.tracking_time;
    //       }

    //       if (this.attendanceIn) {
    //         await this.putSignIn(this.attendance);
    //       } else {
    //         await this.putInToSignout(this.attendance);
    //       }

    //       this.$router.push({
    //         name: "Signed in"
    //       });
    //       this.$toast.success("Success", "submitted", { position: "topCenter" });
    //     } catch (error) {
    //       this.$toast.error("Failed to submit details", "Error", {
    //         position: "topCenter"
    //       });
    //     }
    //   }
  }
};
</script>
